export const BASEURL = 'https://folawej-wash.herokuapp.com/api';
// export const BASEURL = "http://localhost:8200/api";
